import React, { useContext } from 'react';
import { Menu } from '@headlessui/react';
import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Store } from '../../Store';
import userService from '../../services/user.service';

const LANGUAGES = ['es', 'en', 'pt'];

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const { state } = useContext(Store);
  const { userInfo } = state;

  const handleLanguageChange = async lng => {
    await i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);

    // If user is logged in, save language preference to database
    if (userInfo) {
      try {
        const updatedUser = await userService.updateLanguage(userInfo._id, lng);
        // Update userInfo in localStorage with new language
        localStorage.setItem(
          'userInfo',
          JSON.stringify({
            ...userInfo,
            language: updatedUser.language,
          })
        );
      } catch (error) {
        console.error('Error updating language preference:', error);
      }
    }
  };

  return (
    <Menu as='div' className='relative'>
      <Menu.Button className='inline-flex items-center rounded-md bg-white/10 px-3 py-2 text-sm font-medium text-white hover:bg-white/20'>
        <GlobeAltIcon className='h-5 w-5 mr-2' aria-hidden='true' />
        {i18n.language.toUpperCase()}
      </Menu.Button>
      <Menu.Items className='absolute right-0 mt-2 w-24 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'>
        {LANGUAGES.map(lng => (
          <Menu.Item key={lng}>
            {({ active }) => (
              <button
                onClick={() => handleLanguageChange(lng)}
                className={`${
                  active ? 'bg-gray-100' : ''
                } block w-full text-left px-4 py-2 text-sm text-gray-700`}
              >
                {lng.toUpperCase()}
              </button>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
}

export default LanguageSwitcher;
